import React, { useState, useEffect } from "react";
import { BlogPost } from "../entities/BlogPost";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function NewsletterPage() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    const data = await BlogPost.list("-created_date");
    setPosts(data);
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[var(--brand)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-14">
      <div className="page-wrap">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-5xl md:text-7xl mb-4 text-center"
        >
          Newsletter
        </motion.h1>
        <p className="text-center text-[var(--muted)] mb-12 text-lg">
          Product notes, drop updates, and studio process from behind the scenes.
        </p>

        <div className="space-y-8">
          {posts.map((post, index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="panel overflow-hidden grid md:grid-cols-2 gap-0 items-stretch"
            >
              <div className={index % 2 === 0 ? 'md:order-1 min-h-[260px]' : 'md:order-2 min-h-[260px]'}>
                {post.images && post.images[0] && (
                  <img 
                    src={post.images[0]}
                    alt={post.title}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              
              <div className={`${index % 2 === 0 ? 'md:order-2' : 'md:order-1'} p-7 md:p-9`}>
                {post.number && (
                  <p className="chip mb-4">Issue {post.number}</p>
                )}
                <h2 className="text-3xl md:text-4xl mb-3">
                  {post.title}
                </h2>
                {post.subtitle && (
                  <h3 className="text-lg text-[var(--muted)] mb-4">{post.subtitle}</h3>
                )}
                <p className="text-[var(--muted)] leading-relaxed mb-6">
                  {post.excerpt || post.content?.substring(0, 200) + '...'}
                </p>
                <Link
                  to={`/blog/${post.id}`}
                  className="btn-outline inline-flex px-5 py-2.5 text-xs uppercase tracking-[0.12em]"
                >
                  Read More
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
}